module.exports = __webpack_public_path__ + "./docs/img/vox-sdk.c6330b16074ba876c68baf5d64736153.svg";